"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CenteredStack = exports.Title = exports.Wrap = void 0;
const app_1 = require("@obvio/app");
const Stack_1 = require("../Stack");
exports.Wrap = app_1.styled.div `
  padding: ${(theme) => theme.spacing.small} 0;
  background-color: ${(theme) => theme.colors.primary};
  color: ${(theme) => theme.colors.secondary};
  height: 4.0625rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
exports.Title = app_1.styled.span `
  font-size: 0.875rem;
  line-height: 1rem;
  letter-spacing: 0;
`;
exports.CenteredStack = (0, app_1.styled)(Stack_1.Stack) `
  align-items: center;
`;
